'use client'

import React from 'react'
import { YouTubeEmbed } from '../../components/YouTubeEmbed'
import type { VideoBlock2Data } from './config'

interface SingleVideoProps {
  videoIdOrUrl: string
  title?: string | null
}

const SingleVideo: React.FC<SingleVideoProps> = ({ videoIdOrUrl, title }) => {
  const extractYouTubeID = (input: string): string | null => {
    // Try common URL forms first
    const urlMatch = input.match(
      /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/ ]{11})/i,
    )
    if (urlMatch?.[1]) return urlMatch[1]

    // Or accept a bare 11-char ID
    if (/^[a-zA-Z0-9_-]{11}$/.test(input)) return input

    return null
  }

  const videoID = extractYouTubeID(videoIdOrUrl)
  if (!videoID) return null

  return (
    <div className="flex flex-col">
      <div className="w-full overflow-hidden rounded-3xl border-0 mb-3">
        <YouTubeEmbed videoId={videoID} className="rounded-3xl border-0" />
      </div>
      {title && (
        <div className="text-center">
          <h3 className="text-lg font-semibold text-muted-foreground">{title}</h3>
        </div>
      )}
    </div>
  )
}

export const VideoBlock2: React.FC<VideoBlock2Data> = ({ title, videos }) => {
  if (!videos || videos.length === 0) return null

  return (
    <div className="container mx-auto">
      {title && (
        <div className="mb-6 text-center">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground">{title}</h2>
        </div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-8 gap-x-5">
        {videos.map((video, index) => (
          <SingleVideo
            key={video.id || index}
            videoIdOrUrl={video.videoIdOrUrl}
            title={video.title}
          />
        ))}
      </div>
    </div>
  )
}

export default VideoBlock2
